export default "__VITE_ASSET__DlZXvYaX__"